import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogProps, DialogType, DialogWidget, HorizontalOriginOption, HostedStackedElementContainer, VerticalOriginOption } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../codegen/Localize';

export function DatasourceEditConfirmDialog(params: EditConfirmDialogBodyProps
): JSX.Element {

  const FooterContent: JSX.Element = (
    <DialogFooterButtonsWidget
      testId={'datasource-edit-confirm-footer'}
      buttons={[
        {
          handleClick: () => {
            params.onCancel();
          },
          buttonType: ButtonType.LowEmphasis,
          children: Messages.cancel(),
          testId: 'datasource-edit-cancel',
        },
        {
          handleClick: () => {
            params.onContinue();
          },
          buttonType: ButtonType.LowEmphasis,
          children: Messages.continueMessage(),
          testId: 'datasource-edit-continue',
        },
      ]}
    />
  );

  const DialogContent: JSX.Element = (
    <div data-tb-test-id={'datasource-edit-confirm-message'}>
      {Messages.datasourceEditConfirmMessage()}
    </div>
  );

  const dialogProps: DialogProps = {
    dialogWidth: 310,
    type: DialogType.LightweightTitleBar,
    positioningBehavior: params.anchorElementRef !== undefined ? DialogPositioningBehavior.Anchored : DialogPositioningBehavior.Centered,
    anchorEl: params.anchorElementRef !== undefined ? params.anchorElementRef : undefined,
    anchorOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.top },
    testId: 'datasource-edit-confirm',
    title: Messages.datasourceEditConfirmTitle(),
    onCloseRequest: () => params.onCancel,
    showCloseButton: false,
    showFooter: true,
    isModal: true,
    disableAutoFocus: true,
    footerContent: FooterContent,
    children: DialogContent,
  };

  return <DialogWidget {...dialogProps} />;
}

export type EditConfirmDialogBodyProps = {
  anchorElementRef?: HTMLElement;
  readonly onContinue: () => void;
  readonly onCancel: () => void;
};

export async function openEditConfirmDialog(anchorElementRef?: HTMLElement): Promise<void> {
  return new Promise((resolve, reject) => {
    const hostContainer = new HostedStackedElementContainer();
    const close = () => {
      hostContainer && hostContainer.remove();
    };
    const props: EditConfirmDialogBodyProps = {
      anchorElementRef: anchorElementRef,
      onContinue: () => {
          close();
          resolve();
      },
      onCancel: () => {
        close();
        reject();
      }
    };
    const dialog = React.createElement(DatasourceEditConfirmDialog, props);
    hostContainer.render(dialog);
  });
}
